
export class CommonSidebarConstants {
    public static NavigationTabMaxWidth = 225;
    public static SearchTabMaxWidth = 318;
    public static MeetingTabMaxWidth = 358;
}
